import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

export type WorkLogPriorityColor = 'green' | 'yellow' | 'orange' | 'red';

export type PersonalWorkLogEntry = {
    personalWorkLogEntryId: number;
    workDate: string;
    title: string;
    ticketId?: string | null;
    durationMinutes: number;
    technicalNotes?: string | null;
    notes?: string | null;
    isCompleted: boolean;
    sortOrder: number;
    priorityColor?: WorkLogPriorityColor | string | null;
    createdDate?: string;
    updatedDate?: string;
};

const GetPersonalWorkLogWeek = (params: { FromDate: string; ToDate: string }): Promise<{ entries: PersonalWorkLogEntry[] }> =>
    request({
        url: ApiURL.Query.PERSONAL_WORK_LOG_WEEK,
        method: RequestType.GET,
        params,
    });

const JiraTrackerQuery = {
    GetPersonalWorkLogWeek,
};

export default JiraTrackerQuery;
